/*
 * Filename: d:\projects\AutoFiFront\src\Theme\SelectStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 3:23:37 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const SelectStyled = styled.select.attrs((props: any) => ({
    bgColor: props.bgColor,
    borderWidth: props.borderWidth
}))`
@keyframes apparition {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  10% {
    opacity: 0.1;
    transform: translateY(-25px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
appearance: none;
border-radius: 5px;
height: 3rem;
background-color: #fff;
padding: 0 0.5rem;
position: relative;
animation: apparition 0.5s ease-in-out;
border: solid ${(props: any) => getThemeColor(props.bgColor)};
`;

export default SelectStyled;
